module.exports = __webpack_public_path__ + "img/spr_OsmAbit-450x300.41b175c8.jpg";